
import { Injectable } from '@angular/core';
import { NgxVibrationService } from 'ngx-vibration';

@Injectable({
  providedIn: 'root'
})
export class VibrateService {

  hasVibrationSupport = false;

  constructor(private vibrationService: NgxVibrationService) { }

  ngOnInit() {
    this.hasVibrationSupport = this.vibrationService.hasVibrationSupport();
  }

  vibrate() {
    this.vibrationService.vibrate([200, 100, 200]);
  }

  cancelVibration() {
    this.vibrationService.cancelVibration();
  }
}
